import { defineSlotRecipe } from '@chakra-ui/react';
import { fieldAnatomy } from '@chakra-ui/react/anatomy';

export const fieldRecipe = defineSlotRecipe({
  className: 'ac-field',
  slots: fieldAnatomy.keys(),
  base: {
    root: {
      display: 'flex',
    },
    label: {
      color: 'grey.dark.2',
      fontSize: '15px',
      letterSpacing: '0.15px',
      lineHeight: '20px',
    },
  },
  variants: {
    variant: {
      standalone: {
        root: {
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'flex-start',

          _notFirst: {
            marginTop: '16px',
          },
        },
        label: {
          fontWeight: 600,
          marginBottom: '6px',
        },
      },
      form: {
        root: {
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '20px',

          _notFirst: {
            marginTop: '16px',
          },
        },
        label: {
          fontWeight: 400,
        },
      },
      justified: {
        root: {
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '20px',

          _notFirst: {
            marginTop: '16px',
          },
        },
        label: {
          fontWeight: 400,
          userSelect: 'none',
        },
      },
      deviceForm: {
        root: {
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
        },
        label: {
          fontWeight: 400,
          marginBottom: '5px',
        },
      },
      subsection: {
        root: {
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '20px',

          _notFirst: {
            marginTop: '16px',
          },
        },
        label: {
          fontWeight: 400,
        },
      },
    },
  },
  defaultVariants: {
    variant: 'standalone',
  },
});
